import React from 'react';

export default function CompareModal({
  showCompareModal,
  setShowCompareModal,
  compareDay,
  setCompareDay,
  userPhotos,
  selectedDay,
  compareMode,
  setCompareMode,
  showAnatomicalGuide,
  setShowAnatomicalGuide,
  baseScale, setBaseScale,
  baseX, setBaseX,
  baseY, setBaseY,
  topScale, setTopScale,
  topX, setTopX,
  topY, setTopY,
  sliderPos, setSliderPos,
  blendOpacity, setBlendOpacity,
  activeLayer, setActiveLayer
}) {
  if (!showCompareModal) return null;

  return (
    <div className="fixed inset-0 bg-black/95 z-50 flex flex-col items-center justify-between p-4 overflow-y-auto animate-fadeIn">
      <div className="w-full max-w-sm flex justify-between items-center py-2">
        <h3 className="text-[10px] font-bold text-white uppercase tracking-widest">Alineación de Capas</h3>
        <button onClick={() => setShowCompareModal(false)} className="text-gray-500 font-bold text-xl p-2 hover:text-white transition-colors">✕</button>
      </div>
      <div className="w-full max-w-sm space-y-4">
        <div className="flex justify-between items-center bg-[#111] p-4 rounded-[1.5rem] border border-white/10 text-xs">
          <span className="text-gray-500 font-bold uppercase tracking-wider">Comparar con:</span>
          <select value={compareDay} onChange={(e) => setCompareDay(Number(e.target.value))} className="bg-transparent text-white font-bold outline-none">
            {Object.keys(userPhotos).map(Number).filter(d => d !== selectedDay).map(d => <option key={d} value={d} className="bg-black">Día {d}</option>)}
          </select>
        </div>
        <div className="flex bg-[#111] p-1.5 rounded-full border border-white/10 text-[10px] font-bold uppercase tracking-widest">
          <button onClick={() => setCompareMode('blend')} className={`flex-1 py-3 rounded-full transition-all ${compareMode === 'blend' ? 'bg-white text-black' : 'text-gray-500'}`}>Fusión</button>
          <button onClick={() => setCompareMode('slider')} className={`flex-1 py-3 rounded-full transition-all ${compareMode === 'slider' ? 'bg-white text-black' : 'text-gray-500'}`}>Cortinilla</button>
          <button onClick={() => setShowAnatomicalGuide(!showAnatomicalGuide)} className={`px-4 py-3 rounded-full transition-all ${showAnatomicalGuide ? 'bg-white text-black' : 'text-gray-500'}`}>Guía</button>
        </div>
      </div>

      <div className="relative w-full max-w-sm aspect-[9/16] bg-black rounded-[2rem] overflow-hidden border border-white/20 my-4 shadow-2xl flex items-center justify-center">
        {userPhotos[compareDay] && (
          <img src={userPhotos[compareDay]} alt="Compare base" className="absolute inset-0 w-full h-full object-cover" style={{ transform: `scale(${baseScale}) translate(${baseX}px, ${baseY}px)` }} />
        )}
        {userPhotos[selectedDay] && (
          <div className="absolute inset-0 overflow-hidden" style={{ clipPath: compareMode === 'slider' ? `polygon(0 0, ${sliderPos}% 0, ${sliderPos}% 100%, 0 100%)` : 'none', opacity: compareMode === 'blend' ? blendOpacity : 1 }}>
            <img src={userPhotos[selectedDay]} alt="Compare top" className="w-full h-full object-cover" style={{ transform: `scale(${topScale}) translate(${topX}px, ${topY}px)` }} />
          </div>
        )}
        {compareMode === 'slider' && <div className="absolute inset-y-0 w-0.5 bg-white shadow-[0_0_12px_black] z-10" style={{ left: `${sliderPos}%` }} />}
        
        {showAnatomicalGuide && (
          <div className="absolute inset-0 pointer-events-none z-20 flex items-center justify-center p-4">
            <svg viewBox="0 0 100 200" className="w-full h-full stroke-white/50 fill-none" strokeWidth="0.8" strokeDasharray="2 1"><circle cx="50" cy="22" r="8" /><path d="M 40 38 L 60 38 M 42 75 L 58 75" /></svg>
          </div>
        )}
      </div>

      <div className="w-full max-w-sm bg-[#111] p-6 rounded-[2rem] border border-white/10 space-y-6">
        <div className="flex bg-black/50 p-1.5 rounded-full border border-white/5 justify-between items-center text-[9px] uppercase tracking-widest font-bold">
          <span className="text-gray-500 px-4">EDITAR:</span>
          <div className="flex gap-1">
            <button onClick={() => setActiveLayer('base')} className={`px-5 py-2.5 rounded-full transition-all ${activeLayer === 'base' ? 'bg-white text-black' : 'text-gray-500 hover:text-gray-300'}`}>BASE</button>
            <button onClick={() => setActiveLayer('top')} className={`px-5 py-2.5 rounded-full transition-all ${activeLayer === 'top' ? 'bg-white text-black' : 'text-gray-500 hover:text-gray-300'}`}>CAPA</button>
          </div>
        </div>

        {compareMode === 'blend' ? (
          <div>
            <div className="flex justify-between text-[10px] text-gray-500 font-bold uppercase tracking-wider mb-2"><span>Opacidad Sup:</span><span className="text-white">{Math.round(blendOpacity * 100)}%</span></div>
            <input type="range" min="0" max="1" step="0.05" value={blendOpacity} onChange={(e) => setBlendOpacity(parseFloat(e.target.value))} className="w-full accent-white" />
          </div>
        ) : (
          <div>
            <div className="flex justify-between text-[10px] text-gray-500 font-bold uppercase tracking-wider mb-2"><span>Línea:</span><span className="text-white">{sliderPos}%</span></div>
            <input type="range" min="0" max="100" value={sliderPos} onChange={(e) => setSliderPos(Number(e.target.value))} className="w-full accent-white" />
          </div>
        )}

        <div className="grid grid-cols-3 gap-4">
          <div>
            <label className="text-[9px] font-bold uppercase text-gray-500 block mb-2">Zoom</label>
            <input type="range" min="0.8" max="1.4" step="0.01" value={activeLayer === 'top' ? topScale : baseScale} onChange={(e) => { const v = parseFloat(e.target.value); activeLayer==='top'?setTopScale(v):setBaseScale(v); }} className="w-full accent-white" />
          </div>
          <div>
            <label className="text-[9px] font-bold uppercase text-gray-500 block mb-2">X (Horiz)</label>
            <input type="range" min="-40" max="40" step="1" value={activeLayer === 'top' ? topX : baseX} onChange={(e) => { const v = parseInt(e.target.value, 10); activeLayer==='top'?setTopX(v):setBaseX(v); }} className="w-full accent-white" />
          </div>
          <div>
            <label className="text-[9px] font-bold uppercase text-gray-500 block mb-2">Y (Vert)</label>
            <input type="range" min="-40" max="40" step="1" value={activeLayer === 'top' ? topY : baseY} onChange={(e) => { const v = parseInt(e.target.value, 10); activeLayer==='top'?setTopY(v):setBaseY(v); }} className="w-full accent-white" />
          </div>
        </div>
        <button onClick={() => { setTopScale(1); setTopX(0); setTopY(0); setBaseScale(1); setBaseX(0); setBaseY(0); }} className="w-full py-4 bg-[#222] border border-white/10 text-white font-black rounded-full text-[10px] uppercase tracking-widest">
          REINICIAR ALINEACIÓN
        </button>
      </div>
    </div>
  );
}